import { Moment } from "moment-timezone";
import { useEffect } from "react";
import ScheduleCalendarDatesHeader from "./ScheduleCalendarDatesHeader";

type ResponsiveScheduleCalendarDatesHeaderProps = {
  selectedDate: Moment;
  viewingDate: Moment;
  showDates?: boolean;
  onChangeViewingDate: (date: Moment) => void;
  highlightSelectedDate?: boolean;
};

export default function ResponsiveScheduleCalendarDatesHeader(
  props: ResponsiveScheduleCalendarDatesHeaderProps
) {
  useEffect(() => {
    console.log("ResponsiveScheduleCalendarDatesHeader: useEffect");
  }, [props.viewingDate]);

  return (
    <>
      <div className="grid grid-cols-7 text-sm leading-6 text-gray-500 sm:hidden">
        <ScheduleCalendarDatesHeader {...props} compact={true} />
      </div>

      <div className="ltr:-mr-px rtl:-ml-px hidden grid-cols-7 divide-x divide-gray-100 ltr:border-r rtl:border-l border-gray-100 text-sm leading-6 text-gray-500 sm:grid">
        <div className="col-end-1 w-14" />
        <div className="col-end-1 w-14" />
        <ScheduleCalendarDatesHeader {...props} compact={false}/>
      </div>
    </>
  );
}
